import Resource from './Resource'

export default class DailyLog extends Resource {
  static ENDPOINT = '/api/dailylog'

  constructor (args) {
    super()
    this.training = ''
    this.teacher = {}
    this.logDate = new Date()
    this.present = 0
    this.attendance = 0
    this.absence = 0
    this.lateness = 0
    this.earlyLeave = 0
    this.topic = ''
    this.content = ''
    this.request = ''
    this.etc = ''
    Object.keys(args).forEach(arg => {
      this[arg] = args[arg]
    })
  }

  static create (training, teacher, logDate) {
    teacher = {
      _id: teacher._id,
      name: teacher.name
    }
    return new DailyLog({ training, teacher, logDate })
  }
}
